import { useSelector, useDispatch } from "react-redux";
import { selectMessages, hideMessage } from "../store/reducers/message";
import Message from "./Message";
import { useEffect } from "react";

const Messages = (props) => {
  const dispatch = useDispatch();
  const messages = useSelector(selectMessages);

  useEffect(() => {
      const timers = messages?.map((_, index) => {
          return setTimeout(() => {
              dispatch(hideMessage(index));
          }, 5000);
      });

      return () => {
          timers?.forEach(timer => clearTimeout(timer));
      };
  }, [messages?.length, dispatch]);


  return (
    <div {...props}>
      {messages?.map((message, index) => (
        <Message
          key={`message-${index}`}
          message={message.message}
          variant={message.variant}
          index={index}
        />
      ))}
    </div>
  );
};

export default Messages;
